import moment from "moment";

let accessToken = null;
let refreshToken = null;
let tokenExpiry = null;

class AuthService {
  setTokens({ accessToken: at, refreshToken: rt, expiry } = {}) {
    if (at !== undefined) accessToken = at;
    if (rt !== undefined) refreshToken = rt;
    if (expiry !== undefined) tokenExpiry = expiry;
  }

  setExpiry(expiryUnixSeconds) {
    tokenExpiry = expiryUnixSeconds;
  }

  isAuthenticated() {
    try {
      // localStorage.getItem("encryptToken")
      if (!accessToken || !tokenExpiry) return false;
      return Number(tokenExpiry) > moment().unix();
    } catch (error) {
      console.log("Auth error", error);
      return false;
    }
  }

  logout() {
    accessToken = null;
    refreshToken = null;
    tokenExpiry = null;
    window.location.href = "/login";
  }

  getToken() {
    return accessToken || null;
  }

  getRefreshToken() {
    return refreshToken || null;
  }
}

export const authService = new AuthService();
